import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import './AccountMenu.css';

// Logged-in account control: an ovular pill in the header showing the user's
// email so they know who they're signed in as, doubling as the account menu.
const AccountMenu = () => {
    const { email, logout, isAdmin, isBroker } = useAuth();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const initial = (email || '?').charAt(0).toUpperCase();

    return (
        <div
            className="gh-account"
            onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false); }}
        >
            <button
                type="button"
                className="gh-account-pill"
                aria-haspopup="menu"
                aria-expanded={open}
                aria-label="Account menu"
                title={email}
                onClick={() => setOpen((v) => !v)}
            >
                <span className="gh-account-dot">{initial}</span>
                <span className="gh-account-email">{email}</span>
                <span className="gh-account-chev" aria-hidden="true">▾</span>
            </button>

            {open && (
                <div className="gh-account-menu" role="menu">
                    <div className="gh-account-menu-email" title={email}>{email}</div>
                    {isBroker && (
                        <button
                            type="button"
                            role="menuitem"
                            className="gh-account-item"
                            onClick={() => { setOpen(false); navigate('/brokers'); }}
                        >
                            Broker portal
                        </button>
                    )}
                    {isAdmin && (
                        <button
                            type="button"
                            role="menuitem"
                            className="gh-account-item"
                            onClick={() => { setOpen(false); navigate('/admin'); }}
                        >
                            Admin
                        </button>
                    )}
                    <button
                        type="button"
                        role="menuitem"
                        className="gh-account-item gh-account-logout"
                        onClick={() => { setOpen(false); logout(); }}
                    >
                        Log out
                    </button>
                </div>
            )}
        </div>
    );
};

export default AccountMenu;
